import { render, staticRenderFns, recyclableRender, components } from "./u--form.vue?vue&type=template&id=5e58019d&"
var renderjs
import script from "./u--form.vue?vue&type=script&lang=js&"
export * from "./u--form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Program Files/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uview-ui/components/u--form/u--form.vue"
export default component.exports